import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanTimelineRoute: InvariantJiraRoute = {
	name: 'software-plan-timeline',
	path: '/jira/plans/:planId/scenarios/:scenarioId/timeline',
};
